export default function InstantMixIcon(props) {
  return (
    <svg {...props} fill="none" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.16667 16.6693V10.8359H2.5V9.16927H7.5V10.8359H5.83333V16.6693H4.16667ZM4.16667 7.5026V3.33594H5.83333V7.5026H4.16667ZM7.5 7.5026V5.83594H9.16667V3.33594H10.8333V5.83594H12.5V7.5026H7.5ZM9.16667 16.6693V9.16927H10.8333V16.6693H9.16667ZM14.1667 16.6693V14.1693H12.5V12.5026H17.5V14.1693H15.8333V16.6693H14.1667ZM14.1667 10.8359V3.33594H15.8333V10.8359H14.1667Z"
        fill="currentColor"
      />
    </svg>
  );
}
